export default "__VITE_ASSET__BTvQo03r__"